import { Typography } from '@mui/material'
import React, { ComponentPropsWithRef } from 'react'
import { toBoldStrings } from '../../i18n/useTranslation'
import { isMobilePortrait } from '../../utils'

interface Props extends ComponentPropsWithRef<'div'> {
    title: string
}
const hx = isMobilePortrait() ? 'h6' : 'h5'

export const MainTitle = (p: Props) => {
    const { className, title, ...rest } = p
    const textChunks = toBoldStrings(title);
    console.log('textChunks', textChunks)
    return (
        <div className="flex w-[90vw] flex-row justify-center items-center flex-wrap my-2">
            {textChunks.map((s, i) => (
                <Typography
                    key={i}
                    color="primary"
                    id={s}
                    component="span"
                    variant={hx}
                    className={`text-center ${
                        i % 2 === 1 ? 'font-bold' : ''
                    }`}
                    sx={{
                        // overflow: 'visible',
                        // textOverflow: 'ellipsis',
                        lineHeight: 1,
                        // whiteSpace: 'pre-line',
                        // wordWrap: 'break-word',
                    }}
                >
                    {s}
                </Typography>
            ))}
        </div>
    )
}
